let view = null;

export default {
	namespace: 'template-publications',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: PublicationsView } = await import(
			/* webpackChunkName: "publications-view" */ '../../templates/PublicationsView'
		);
		view = new PublicationsView(next.container);
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
